import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
	templateUrl: 'terms.page.html',
	styleUrls: ['terms.page.scss']
})
export class TermsPage implements OnInit {
	constructor(
		private title: Title
	) {
		this.title.setTitle('Terms of Service - TeamTime');
	}

	ngOnInit() {
		//window.scrollTo(0, 0);
	}
}
